### global require, ga, _hmt ###

require 'plugins/pure/pure-min.css'
require 'plugins/icomoon/style.css'
require 'plugins/sweetalert/lib/sweet-alert.css'
require 'styles/common/util.scss'
require 'styles/common/common.scss'
require 'styles/pages/taste.scss'

require 'script!jquery'
require '../common/form-validation.coffee'
require 'script!flexslider'
require 'script!ajaxform'
require '../common/fast-nav.coffee'
require '../common/city.coffee'
require '../common/select2.js'

browser =
  isIE8: !!navigator.userAgent.match(/MSIE 8.0/)
  isIE9: !!navigator.userAgent.match(/MSIE 9.0/)

do->
  ###
 # 轮播图
 ###
  $('#slider').flexslider {
    animation: 'fade'
    directionNav: false
    animationDuration: 800
  }
  ###
  # 顶部报名
  ###
  $form = $('#appointment form')
  $truename = $form.find 'input[name="truename"]'
  $mobile = $form.find 'input[name="mobile"]'
  $btn = $form.find 'button[type="submit"]'
  $agreement = $form.find '[name = agreement]'
  $cunt=$('#cunt')
  browser =
    isIE8: !!navigator.userAgent.match(/MSIE 8.0/)
    isIE9: !!navigator.userAgent.match(/MSIE 9.0/)

  $mobile.on 'focus',->
    $me = $(this)
    $btn.addClass('hover')

  $mobile.on 'blur',->
    $me = $(this)
    $btn.removeClass('hover')

  $form.validate
    errorPlacement: (error,elem)->
      alert(error.html()) if browser.isIE8
      swal {
        type: 'error'
        title: error.html()
        allowOutsideClick: true
        confirmButtonText: '确定'
        confirmButtonColor: '#2F86F9'
      }
    submitHandler: (form)->
      if not browser.isIE8
        phoneNumber=form.elements.mobile.value.trim()
        userId="MOBI#{phoneNumber}"
      $(form).ajaxSubmit
        dataType: 'json'
        error: ->
          alert('对不起！出错了,请稍后重试！') if browser.isIE8
          swal {
            type: 'error'
            title: '对不起！出错了,请稍后重试！'
            allowOutsideClick: true
            confirmButtonText: '确定'
            confirmButtonColor: '#2F86F9'
          }
        success: (res)->
          if res.status is 'success'
            $cunt.html(parseInt($cunt.html())+1)
            swal {
              customClass: 'alert-success'
              title: '<img class="form_success" src="'+$('#alertImg').attr('src')+'" alt="">'
              confirmButtonText: '返  回'
              confirmButtonColor: '#3b9bff'
              allowOutsideClick: true
              html: true
            }
          else
            alert(res.msg[0].info) if browser.isIE8
            swal {
              type: 'error'
              title: res.msg[0].info
              allowOutsideClick: true
              confirmButtonText: '确定'
              confirmButtonColor: '#2F86F9'
            }

        complete: ->
          $btn.removeAttr 'disabled'

  if $agreement.length
    $agreement.rules 'add',{
      required: true
      messages: {
        required: '请勾选已阅读并同意积木家的用户协议'
      }
    }

  $mobile.rules 'add',
    required: true
    mobileNum: true
    messages:
      required: '请输入手机号码'
      mobileNum: '请输入正确手机号码'

  $truename.rules 'add',
    required: true
    messages:
      required: '请输入姓名'
do ->
  $rightFloat=$('.right-float')
  $mfdh=$('.mfdh')
  $height=$("body").height()-($(window).height()-136)
  $(window).scroll ->
    $mfdh.hide()
    scrollTop = $(window).scrollTop()
    if $height<=scrollTop
    else if  480<= scrollTop
      $rightFloat.stop().animate(right:30,50)
    else
      $rightFloat.stop().animate(right:-70,50)




/** WEBPACK FOOTER **
 ** /root/workspace/jimujia-pc_4ez23/wwwroot/static/~/coffeelint-loader!./taste.coffee
 **/